export function agencyProgramLabel(value) {
  return String(value || '')
    .replace(/\s+(?:diploma|certificate)(?:\s+program)?\s*$/i, '')
    .trim();
}

const PROGRAM_ABBREVIATIONS_BY_NAME = {
  'international esports management': 'IEM',
  'international esports management diploma': 'IEM',
  'hospitality operations': 'HO',
  'hospitality operations diploma': 'HO',
  'global management in hospitality': 'GMH',
  'global management in hospitality diploma': 'GMH',
  'business communication pre-requisite program': 'BCP',
  'business communication prerequisite program': 'BCP',
  'french as a second language (fsl)': 'FSL',
  'french test preparation (tcf & tef)': 'FTP',
  'next-gen applied ai mastery': 'NGAI',
  'video content creation and social media management': 'VCSM',
};

const PROGRAM_ABBREVIATIONS_BY_CODE = {
  IEM: 'IEM',
  IEMD: 'IEM',
  HO: 'HO',
  HOD: 'HO',
  GMH: 'GMH',
  GMHD: 'GMH',
  BCP: 'BCP',
  FSL: 'FSL',
  FTP: 'FTP',
  NGAI: 'NGAI',
  VCSM: 'VCSM',
};

function programName(value) {
  if (value && typeof value === 'object') return String(value.name || '').trim();
  return String(value || '').trim();
}

function programRecord(value, meta) {
  if (value && typeof value === 'object') return value;
  const name = programName(value);
  return (Array.isArray(meta?.programRecords) ? meta.programRecords : [])
    .find((record) => String(record?.name || '').trim() === name);
}

function configuredProgramAbbreviation(name, meta) {
  const configured = meta?.programAbbreviations;
  if (!configured || typeof configured !== 'object' || Array.isArray(configured)) return '';
  const direct = String(configured[name] || '').trim();
  if (direct) return direct;
  const normalizedName = name.toLocaleLowerCase('en-CA');
  const matchingKey = Object.keys(configured)
    .find((key) => String(key).trim().toLocaleLowerCase('en-CA') === normalizedName);
  return matchingKey ? String(configured[matchingKey] || '').trim() : '';
}

function inferredProgramAbbreviation(name) {
  const label = agencyProgramLabel(name);
  const parenthetical = label.match(/\(([A-Z][A-Z0-9]*(?:\s*[&/]\s*[A-Z0-9]+)*)\)\s*$/);
  if (parenthetical) return parenthetical[1].replace(/\s+/g, '');

  const initials = label
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .filter((word) => !['a', 'an', 'and', 'as', 'in', 'of', 'the'].includes(word.toLowerCase()))
    .map((word) => word[0])
    .join('')
    .toUpperCase();
  if (initials.length >= 2) return initials.slice(0, 8);
  return label.length <= 8 ? label.toUpperCase() : label;
}

export function agencyProgramAbbreviation(value, meta = {}) {
  const name = programName(value);
  if (!name) return '';

  const record = programRecord(value, meta);
  const configured = configuredProgramAbbreviation(name, meta);
  const recordAbbreviation = String(record?.abbreviation || '').trim();
  const normalizedName = name.toLocaleLowerCase('en-CA');
  const code = String(record?.code || '').trim().toUpperCase();

  return (
    configured
    || recordAbbreviation
    || PROGRAM_ABBREVIATIONS_BY_NAME[normalizedName]
    || PROGRAM_ABBREVIATIONS_BY_CODE[code]
    || inferredProgramAbbreviation(name)
  ).toUpperCase();
}

export function agencyProgramOptionLabel(value, meta = {}) {
  const name = programName(value);
  if (!name) return '';
  const abbreviation = agencyProgramAbbreviation(value, meta);
  return abbreviation && abbreviation !== name.toUpperCase()
    ? `${abbreviation} — ${name}`
    : name;
}
